(() => {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const get = id => root.querySelector('#pp-' + id);
    const paymentId = new URLSearchParams(location.search).get('payment_id');
    get('payment-id').textContent = paymentId || 'Geen referentie gevonden';
    let tries = 0, timer, controller;
    const maxTries = 120;
    function state(type, label, status, message) {
      get('status-label').textContent = label;
      get('payment-status').textContent = status;
      get('thankyou-subtitle').textContent = message;
      get('thankyou-title').textContent = type === 'paid' ? 'Bedankt voor je bestelling' : 'Je betaling controleren';
      ['status-icon','status-dot','progress'].forEach(id => { get(id).classList.remove('is-paid','is-pending','is-error'); get(id).classList.add('is-' + type); });
      get('status-icon').innerHTML = type === 'paid' ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 12 4 4L20 5"/></svg>' : type === 'error' ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 6 12 12M6 18 18 6"/></svg>' : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 6v6l4 2"/></svg>';
    }
    function waiting() { state('pending','Betaling wordt bevestigd','In verwerking','We controleren je betaling automatisch. Je betaling is nog niet definitief bevestigd.'); }
    function schedule() {
      if (tries < maxTries) timer = setTimeout(check, 2500);
      else {
        state('pending','Bevestiging nog niet ontvangen','Nog niet bevestigd','We kunnen je betaling op dit moment niet bevestigen. Controleer de status later opnieuw of neem contact op met de klantenservice.');
        get('retry').hidden = false;
      }
    }
    async function check() {
      if (!root.isConnected) return;
      tries++;
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(root.dataset.paymentStatusEndpoint);
        url.searchParams.set('payment_id', paymentId);
        const response = await fetch(url.href, { headers: { Accept:'application/json' }, cache:'no-store', signal:controller.signal });
        if (!response.ok) throw new Error('Status niet beschikbaar');
        const data = await response.json();
        const status = String(data.status || '').toLowerCase();
        if (['failed','expired','cancelled','canceled'].includes(status)) {
          state('error','Betaling niet afgerond','Niet betaald','De betaling is geannuleerd, verlopen of mislukt. Neem bij twijfel contact op met de klantenservice voordat je opnieuw betaalt.');
          get('retry').hidden = false; return;
        }
        if (data.found !== false && (data.paid === true || status === 'paid' || status === 'settled')) {
          state('paid','Betaling bevestigd','Betaald','Je betaling is succesvol bevestigd. Bedankt voor je bestelling.');
          get('retry').hidden = true;
          // Any shop analytics integration may subscribe; no old store pixel is loaded here.
          root.dispatchEvent(new CustomEvent('milwaukee:payment-confirmed', { bubbles:true, detail:{ paymentId, amount:data.amount, currency:data.currency } }));
          return;
        }
        waiting();
      } catch (_) {
        state('pending','Status tijdelijk niet beschikbaar','Nog niet bevestigd','We kunnen de betaalstatus nu niet ophalen. We proberen het automatisch opnieuw.');
      } finally { clearTimeout(timeout); }
      schedule();
    }
    get('retry').addEventListener('click', () => { clearTimeout(timer); tries=0; get('retry').hidden=true; waiting(); check(); });
    if (!paymentId) { state('pending','Betaalreferentie ontbreekt','Niet te controleren','Open de terugkeerlink van je betaling om de status te controleren. Neem bij vragen contact op met de klantenservice.'); return; }
    if (root.dataset.designMode === 'true') { state('pending','Voorbeeldweergave','Niet gecontroleerd','Dit is een voorbeeld in de thema-editor. Er wordt geen betaalstatus opgevraagd.'); return; }
    waiting(); check();
    window.addEventListener('pagehide', () => { clearTimeout(timer); controller?.abort(); });
    window.addEventListener('pageshow', event => { if (event.persisted) { tries=0; waiting(); check(); } });
  }
  document.querySelectorAll('.pp-thankyou-page').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.pp-thankyou-page').forEach(init));
})();
